import logo from "@/assets/logo.png";

// Centered branded shell for all authentication screens.
export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-10">
          <img src={logo} alt="BeSca" className="h-[50px] w-auto" />
        </div>
        <div className="bg-white border border-border p-8 shadow-sm">
          <h1 className="font-heading text-2xl font-medium tracking-tight">{title}</h1>
          {subtitle && (
            <p className="text-muted-foreground text-sm mt-1">{subtitle}</p>
          )}
          <div className="mt-6">{children}</div>
        </div>
        {footer && (
          <div className="text-center text-sm text-muted-foreground mt-6">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
